import Image from 'next/image';
import { useTranslation } from 'react-i18next';

import { WebBodyText18, WebHeading28 } from '@fintronners/react-ui/src/GlobalStyling/webTypography';

import { SuccessCircleIcon } from '@/assets/icons';
import { Button } from '@/components/common/Button';
import { SheetContent, SheetFooter, SheetTitle } from '@/components/common/Sheet';
import { useSidePanel } from '@/context/SidePanelContext';

export const Success = () => {
  const { closeSidePanel } = useSidePanel();
  const { t } = useTranslation();

  const handleClose = () => closeSidePanel();

  return (
    <SheetContent>
      <div className="flex flex-col items-center gap-7 text-center mt-20">
        <Image alt="Success icon" width={50} height={50} src={SuccessCircleIcon.src} />
        <SheetTitle>
          <WebHeading28.Bold className="text-darkestBlue">
            {t('settings.security.changePassword.success.title')}
          </WebHeading28.Bold>
        </SheetTitle>
        <WebBodyText18.Regular className="text-grey72">
          {t('settings.security.changePassword.success.description')}
        </WebBodyText18.Regular>
      </div>
      <SheetFooter className="text-center mb-5">
        <Button className="w-full" onClick={handleClose}>
          {t('common.done')}
        </Button>
      </SheetFooter>
    </SheetContent>
  );
};
